const RecommendedLength = {
    CopyLeaks: -1
};

export { RecommendedLength };
